<template>
  <div>
    <v-row>
      <v-col cols="12">
        <p class="text-2xl">
          Tarifas Whitelabel
        </p>
        <v-card flat>
          <v-card-text class="pa-3">
            <v-row>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-autocomplete
                  v-model="filterWhitelabelId"
                  :items="whitelabels"
                  label="Whitelabel"
                  outlined
                  dense
                  hide-details
                  item-text="value"
                  item-value="id"
                  @change="fetchTaxes"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-select
                  v-model="filterServiceId"
                  :items="services"
                  label="Tipo"
                  outlined
                  dense
                  hide-details
                  item-text="name"
                  item-value="id"
                  @change="fetchTaxes"
                />
              </v-col>
              <v-col
                cols="12"
                md="4"
                sm="6"
              >
                <v-btn
                  color="primary"
                  class="pl-4"
                  @click="fetchTaxes"
                >
                  Pesquisar
                  <v-icon
                    right
                    dark
                  >
                    {{ icons.mdiFileEdit }}
                  </v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn
              color="primary"
              class="pl-4"
              outlined
              @click="openFormToCreate"
            >
              Novo Registro
              <v-icon
                right
                dark
              >
                {{ icons.mdiTablePlus }}
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>

        <v-card
          flat
          class="mt-5"
        >
          <v-data-table
            :headers="headers"
            :items="rows"
            item-key="id"
            class="table-rounded"
            disable-sort
            dense
            no-data-text="Selecione um whitelabel para visualizar as tarifas configuradas."
          >
            <template #[`item.action`]="{item}">
              <v-btn
                color="success"
                dark
                text
                title="Editar"
                x-small
                @click="openFormToEdit(item)"
              >
                <v-icon>{{ icons.mdiFileEdit }}</v-icon>
              </v-btn>
            </template>
            <template #[`item.serviceId`]="{item}">
              {{ resolveServiceName(item) }}
            </template>
            <template #[`item.customerLevelId`]="{item}">
              {{ resolveCustomerLevelName(item.customerLevelId) }}
            </template>
            <template #[`item.unitaryValue`]="{item}">
              R$ {{ $money(item.unitaryValue, 4) }}
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <validation-observer
      ref="formTax"
      autocomplete="off"
      tag="form"
      @keyup.enter="fetchAction"
    >
      <dialog-form
        :status="formDialogStatus"
        :is-update="formIsUpdate"
        :title="'Cadastro de Tarifa'"
        :width="900"
        @action="fetchAction"
        @remove="removeDialogStatus = true"
        @close="formDialogStatus = !formDialogStatus"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Whitelabel"
              rules="required"
              vid="form.whitelabelId"
            >
              <v-autocomplete
                v-model="form.whitelabelId"
                :items="whitelabels"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                outlined
                dense
                item-text="value"
                item-value="id"
                label="Whitelabel"
              />
            </validation-provider>
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Tipo"
              rules="required"
              vid="form.serviceId"
            >
              <v-select
                v-model="form.serviceId"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                :items="services"
                label="Tipo"
                dense
                outlined
                item-text="name"
                item-value="id"
              />
            </validation-provider>
          </v-col>
          <template v-if="form.serviceId === 31">
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Agente"
              rules="required"
              vid="form.supplier"
            >
              <v-select
                v-model="form.supplier"
                :items="suppliers"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                outlined
                dense
                item-text="text"
                item-value="value"
                label="Agente"
              />
            </validation-provider>
          </v-col>
          </template>
          <!-- <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Nível"
              rules="required"
              vid="form.customerLevelId"
            >
              <v-select
                v-model="form.customerLevelId"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                :items="customerLevels"
                label="Nível"
                dense
                outlined
                item-text="name"
                item-value="id"
              />
            </validation-provider>
          </v-col> -->
          <v-col
            cols="12"
            md="6"
          >
            <validation-provider
              v-slot="{ errors }"
              name="Valor (R$)"
              rules="required"
              vid="form.unitaryValue"
            >
              <v-text-field
                v-model="form.unitaryValue"
                v-money="{
                  precision: 4,
                }"
                :error-messages="errors"
                :hide-details="errors.length === 0"
                outlined
                dense
                prefix="R$"
                label="Valor (R$)"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </dialog-form>
    </validation-observer>

    <dialog-remove
      :status="removeDialogStatus"
      :text-to-confirm="form.name"
      @action="fetchActionRemove"
      @close="removeDialogStatus = !removeDialogStatus"
    >
    </dialog-remove>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { mdiFileEdit, mdiMagnify, mdiTablePlus } from '@mdi/js'
import { ref } from '@vue/composition-api'

export default {
  setup() {
    const services = ref([])
    const whitelabels = ref([])
    const filterName = ref(null)
    const filterServiceId = ref(null)
    const filterWhitelabelId = ref(null)
    const formDialogStatus = ref(false)
    const removeDialogStatus = ref(false)
    const formIsUpdate = ref(false)
    const total = ref(null)
    const form = ref({
      id: ref(null),
      name: ref(''),
      whitelabelId: ref(null),
      serviceId: ref(null),
      supplier: ref(null),
      quantity: ref(null),
      unitaryValue: ref(null),
    })

    let suppliers = [
      { text: 'RCS Basic', value: 'basic' },
      { text: 'RCS Single', value: 'single' },
      { text: 'RCS Conversational', value: 'conversational' },
    ]
    return {
      total,
      filterName,
      filterServiceId,
      filterWhitelabelId,
      form,
      formDialogStatus,
      removeDialogStatus,
      formIsUpdate,
      icons: {
        mdiFileEdit,
        mdiMagnify,
        mdiTablePlus,
      },
      headers: [
        { text: 'Ações', value: 'action', align: 'center' },
        { text: 'ID', value: 'id' },
        { text: 'Tipo', value: 'serviceId' },
        // { text: 'Nível', value: 'customerLevelId' },
        { text: 'Valor (R$)', value: 'unitaryValue', align: 'right' },
      ],
      services,
      whitelabels,
      suppliers,
    }

    
  },

  computed: {
    ...mapState('taxes', ['rows']),
  },

  async created() {
    this.services = await this.findServices()
    await this.findWhitelabels()
    this.clearRows()
  },

  methods: {
    ...mapActions('services', { findServices: 'find' }),
    ...mapActions('taxes', ['find', 'findById', 'create', 'update', 'remove']),

    clearRows() {
      this.$store.commit('taxes/setRows', [])
    },

    async findWhitelabels() {
      this.whitelabels = [
        {
          id: 'hlYE7Wp80sZZYdSY0z4moJ2egIhXZZp6KRsu',
          value: 'Betenvios',
        },
        {
          id: 'HZAY4LTEb8C8YqgAW5csO14mgepgw47f7WEa',
          value: 'Hands',
        },
        {
          id: 'BS9mK2qT7xP4vR8cL1nF5wH3yD6uZ0aE',
          value: 'Boostsend',
        },
        {
          id: 'OE1aLfs28HE1D1s25LDwr8A4SSZu2hqfmPWcx',
          value: 'Daxx',
        }
      ]
    },

    resolveServiceName(item) {
      
      const service = this.services.find(service => service.id === item.serviceId)

      if (service) {
        if (item.typeRcs) {
          return service.name + ' - ' + item.typeRcs
        } else {
          return service.name
        }
      }

      return null
    },

    async openFormToCreate() {
      this.formDialogStatus = true
      this.formIsUpdate = false
      this.form = {
        id: null,
        whitelabelId: this.filterWhitelabelId,
        serviceId: null,
        supplier: null,
        customerLevelId: null,
        unitaryValue: null,
      }
    },

    async openFormToEdit(item) {
      const payload = {
        id: item?.id,
        whitelabelId: item?.whitelabelId ?? this.filterWhitelabelId,
      }
      const tax = await this.findById(payload)

      if (tax) {
        await this.$refs.formTax.reset()
        this.formDialogStatus = true
        this.formIsUpdate = true
        this.form = {
          id: tax.id,
          whitelabelId: tax.whitelabelId ?? null,
          serviceId: tax.serviceId,
          customerLevelId: tax.customerLevelId,
          unitaryValue: this.$money(tax.unitaryValue, 4),
        }
      }
    },

    async fetchTaxes() {
      if (!this.filterWhitelabelId) {
        this.clearRows()
        return
      }

      await this.find({
        whitelabelId: this.filterWhitelabelId,
        serviceId: this.filterServiceId,
      })
    },

    async fetchAction(isUpdate) {
      const body = {
        whitelabelId: this.form.whitelabelId,
        serviceId: Number(this.form.serviceId),
        supplier: this.form.supplier,
        unitaryValue: this.$strip(this.form.unitaryValue),
      }

      if (await this.$refs.formTax.validate()) {
        if (isUpdate) await this.update(body)
        else await this.create(body)

        this.fetchTaxes()
        this.formDialogStatus = false
      }
    },

    async fetchActionRemove() {
      try {
        if (this.form.id) {
          await this.remove({
            id: this.form.id,
            whitelabelId: this.form.whitelabelId,
          })
        }
      } finally {
        this.fetchTaxes()
        this.formDialogStatus = false
        this.removeDialogStatus = false
      }
    },
  },
}
</script>
